<ng-container *ngIf="meta$ | async as metaData" xMeta [meta]="metaData"></ng-container>

<ng-container *ngIf="content$ | async as operation" [xOperation]="operation">
  <ng-container *xOperationLoading>
    <x-ghost-section-with-image class="mb-3"></x-ghost-section-with-image>
    <x-ghost-section-one class="mb-3"></x-ghost-section-one>
    <x-ghost-section-with-image class="mb-3" [reverse]="true"></x-ghost-section-with-image>
  </ng-container>
  <ng-container *xOperationResult>
    <ng-container *ngIf="operation?.data?.body?.length; else NOT_FOUND">
      <x-page-layout>
        <div class="channel-content" xHeader>
          <ng-container *ngFor="let section of operation.data?.body">
            <ng-template [xDynamicComponent]="section"></ng-template>
          </ng-container>
        </div>
      </x-page-layout>
    </ng-container>
  </ng-container>
  <ng-container *xOperationError [ngTemplateOutlet]="NOT_FOUND"></ng-container>
</ng-container>

<ng-template #NOT_FOUND>
  <x-page-not-found
    [backToShopping]="false"
    heading="Oops! Missing content"
    subHeading="Feel free to explore other parts of our site."
  ></x-page-not-found>
</ng-template>
